import type { MockSectionCustomerInput } from './mockSectionData.util';
import { readReportFieldSource } from './reportFieldSource.util';
import {
  buildLookingAheadSnapshot,
  coerceEngagementRatePct,
  mockLookingAheadEngagementRatePct,
} from './lookingAheadSnapshot.util';

/**
 * Normalizes looking-ahead snapshots with refreshed customer and period copy.
 * @param snapshot - Stored or live snapshot JSON.
 * @param customer - Customer context for state and footer personalization.
 * @param reportingPeriod - Report period label for the prepared-by line.
 * @returns Snapshot with dynamic narrative and footer fields.
 */
export const normalizeLookingAheadSnapshot = (
  snapshot: Record<string, unknown>,
  customer: MockSectionCustomerInput,
  reportingPeriod: string,
): Record<string, unknown> => {
  const warehouseBacked =
    readReportFieldSource(snapshot, 'engagementRatePct') === 'warehouse';
  const warehouseRate = warehouseBacked
    ? coerceEngagementRatePct(snapshot.engagementRatePct)
    : null;

  return buildLookingAheadSnapshot({
    customer,
    reportingPeriod,
    engagementRatePct:
      warehouseBacked && warehouseRate !== null
        ? warehouseRate
        : mockLookingAheadEngagementRatePct(customer, reportingPeriod),
    engagementRateSource:
      warehouseBacked && warehouseRate !== null ? 'warehouse' : 'mock',
  });
};
